module.exports = __webpack_public_path__ + "static/media/Asset 44.8dc404e0.png";